/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `SALES` - Sales
* `OPERATION` - Operation
 */
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnum = {
  SALES: 'SALES',
  OPERATION: 'OPERATION',
} as const;
